import { Component, OnInit } from '@angular/core';
import { Response } from '@angular/http';
import 'rxjs/Rx';
import { LayoutService } from "../../layout/layout.service";
import { AuthService } from "../../services/auth.service";
import { config } from '../../smartadmin.config';
import { ClientService } from  "../../services/client.service";
@Component({

  selector: 'sa-login-info',
  templateUrl: './login-info.component.html',
})
export class LoginInfoComponent implements OnInit {
  user: any = {};
  skinDefaultName: string = 'qubesense-style-2-default';
  skin: any = {};
  loginInfoBackColor: any = {};
  loginInfoLabelColor: any = {};
  client: any = {};
  constructor(
    private layoutService: LayoutService, private authService: AuthService, private clientService: ClientService) {
    this.user = this.authService.getUser();
    this.authService.getUpdatedUser().subscribe(data => {
      this.user = data;

    });
  }

  ngOnInit() {
    this.client = this.clientService.getClient();
    this.skinDefaultName = this.client.clientSetting.siteSetting.baseTheme || 'qubesense-style-2-default';
    let skins = config.skins;
    let skin = skins.find((_skin) => {
      return _skin.name == this.skinDefaultName
    })
    this.loginInfoBackColor = skin.loginInfoBackColor;

    this.loginInfoLabelColor = skin.loginInfoLabelColor;
    //this.loginInfoColor = JSON.parse(this.client.clientSetting.siteSetting.loginPage.loginBoxBottomStyle || {});
  }

  toggleShortcut() {
    this.layoutService.onShortcutToggle()
  }

}
